
// themes.js

export const lightTheme = {
  background: '#f2f2f2', // Um cinza claro um pouco mais escuro que ainda é suave.
  color: '#333', // Cor do texto
  fieldBackground: '#f2f2f2', // Cor de fundo dos campos (cinza claro)
  buttonBackground: '#666', // Cor de fundo do botão
  buttonText: '#fff', // Cor do texto do botão
};

export const darkTheme = {
  background: '#333',
  color: '#fff',
  fieldBackground: '#f2f2f2', // Cor de fundo dos campos no tema escuro
  buttonBackground: '#555', // Cor de fundo do botão no tema escuro
  buttonText: '#fff', // Cor do texto do botão no tema escuro
};